import z from "zod";
import { UnitIdScheme } from "./ids";
import { SerialScaleUnit } from "./enums/serialScaleUnit";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const UnitDBScheme = z.object({
  id: UnitIdScheme,
  name: z.string(),
  suffix: z.string(),
  decimals: z.number(),
  enableSerialScale: z.boolean().optional(),
  serialScaleUnit: z.enum(SerialScaleUnit).optional(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetUnit = UnitDBScheme;

export const RestCreateUnit = UnitDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
});

export const RestUpdateUnit = UnitDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
}).partial();

export type DBUnit = z.infer<typeof UnitDBScheme>;
export type RestUnit = z.infer<typeof RestGetUnit>;
export type RestCreateUnit = z.infer<typeof RestCreateUnit>;
export type RestUpdateUnit = z.infer<typeof RestUpdateUnit>;
